import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps {
    color?: string;
    className?: string;
    isPartnerTerms?: boolean;
    sourceForm?: {
        source: string;
        isUserLogged?: boolean;
    };
}
export const ApplicationTermsAcceptation = (props: IProps) => {
    const {color = "var(--colors-gray-700)", className, isPartnerTerms, sourceForm} = props;

    const pdfLink = rpAppLink.partnersTerms.base();
    const termsLink = isPartnerTerms ? pdfLink : rpAppLink.termsOfService.base();

    return (
        <Text variant="info_txt_1" color={color || "var(--colors-gray-700)"} className={className} align="center">
            Akceptuję{" "}
            <a href={termsLink} target="_blank" className={linkStyle}>
                regulamin{sourceForm?.source === "applicationSideBar" && !sourceForm?.isUserLogged ? "" : " serwisu."}
            </a>
            {sourceForm?.source === "applicationSideBar" && !sourceForm?.isUserLogged ? " i zakładam konto w Portalu." : ""}
        </Text>
    );
};

const linkStyle = css({
    textDecoration: "underline",
    color: "var(--colors-gray-700)",

    "&, &:link, &:visited, &:hover, &:active": {
        textDecoration: "underline",
        color: "var(--colors-gray-700)"
    }
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps {
    color?: string;
    className?: string;
    isPartnerTerms?: boolean;
    sourceForm?: {
        source: string;
        isUserLogged?: boolean;
    };
}
export const ApplicationTermsAcceptation = (props: IProps) => {
    const {color = "var(--colors-gray-700)", className, isPartnerTerms, sourceForm} = props;

    const pdfLink = rpAppLink.partnersTerms.base();
    const termsLink = isPartnerTerms ? pdfLink : rpAppLink.termsOfService.base();

    return (
        <Text variant="info_txt_1" color={color || "var(--colors-gray-700)"} className={className} align="center">
            Akceptuję{" "}
            <a href={termsLink} target="_blank" className={linkStyle}>
                regulamin{sourceForm?.source === "applicationSideBar" && !sourceForm?.isUserLogged ? "" : " serwisu."}
            </a>
            {sourceForm?.source === "applicationSideBar" && !sourceForm?.isUserLogged ? " i zakładam konto w Portalu." : ""}
        </Text>
    );
};

const linkStyle = css({
    textDecoration: "underline",
    color: "var(--colors-gray-700)",

    "&, &:link, &:visited, &:hover, &:active": {
        textDecoration: "underline",
        color: "var(--colors-gray-700)"
    }
});
